export default __webpack_public_path__ + "media/images/tenant/hero_4-dffb1d72f44244d8a1bfaef0504d6338.jpg";